import * as types from '../../types/reports/reportsTypes';

const initialState = {
  loading: false,
  report: [],
  completed_total_batch_count: 0,
  error: null,
};

const departmentWisePendingReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_DEPARTMENT_WISE_PENDING_REPORT_REQUEST:
      return { ...state, loading: true };
    case types.GET_DEPARTMENT_WISE_PENDING_REPORT_SUCCESS:
      return { ...state, loading: false, report: action.payload, error: null };
    case types.GET_DEPARTMENT_WISE_PENDING_REPORT_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

const departmentWiseProductionReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_DEPARTMENT_WISE_PRODUCTION_REPORT_REQUEST:
      return { ...state, loading: true };
    case types.GET_DEPARTMENT_WISE_PRODUCTION_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        report: Array.isArray(action.payload) ? action.payload : (action.payload.report || []),
        completed_total_batch_count: action.payload.completed_total_batch_count || 0,
        error: null
      };
    case types.GET_DEPARTMENT_WISE_PRODUCTION_REPORT_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export { departmentWisePendingReportReducer, departmentWiseProductionReportReducer }; 